import styled from "styled-components";

export const SupplyLimitDrawerLayout = styled.div`
    margin-left: 3rem;
`;
